
function PhoneCta(settings) {
	if ( arguments.length < 1 ) {
		this.settings = {
			openingBtns 		: document.querySelectorAll('.confirm, .open-modal'), 
			closingBtn 			: document.querySelector('.close-modal'), 
			tooltipEl			: document.querySelector('.cta-tooltip'),
			phoneIcon 			: document.querySelector('.phone-icon'),
			overlay 			: document.querySelector('.overlay-body'),
			formWrapper 		: document.querySelector('.form-wrapper-all'),
			changeFormButtons 	: document.querySelectorAll('.form-pickers'),
			formElements		: document.querySelectorAll('.form-wrapper-all .instance'), 
			numberElements		: document.querySelectorAll('.numbers'),
			minCalls			: 1, 
			maxCalls			: 12,
			debug				: false,
		}
	} else {
		this.settings = settings; 
	}

	this.init();

}

PhoneCta.prototype.init = function() {
	let self = this; 
	let settings = this.settings; 


	// log settings obj if user desires;
	if ( settings.debug == true ) {	
		this.logSettings();
	}
	
	// add listener to opening the overlay and form
	settings.openingBtns.forEach(function(btn){
		self.addEvent(btn, 'click', self.showForm.bind(self));
	});

	// add listeners to form pickers
	// settings.changeFormButtons.forEach(function(btn){
	// 	self.addEvent(btn, 'click', self.changeForm.bind(self))
	// });

	// add listener to close modal 
	self.addEvent(settings.closingBtn, 'click', self.closeModal.bind(self));

	// add listener to show/hide tooltip
	let tooltipControls = [settings.tooltipEl, settings.phoneIcon];
	tooltipControls.forEach(function(ttpBtn){
		self.addEvent(ttpBtn, 'click', self.toggleMessage.bind(self)); 
	});

	// print numbers 
	this.printNumbers();
}

PhoneCta.prototype.logSettings = function() {
	console.log(this.settings);
}

PhoneCta.prototype.showForm = function(e) {
	let settings = this.settings; 

	fadeIn(settings.overlay);

	setTimeout( function() {
		fadeIn(settings.formWrapper); 
	}, 600);
}

PhoneCta.prototype.closeModal = function() {

	let settings = this.settings;

	fadeOut(settings.formWrapper, function(){
		fadeOut(settings.overlay, null);
	}); 

}

PhoneCta.prototype.toggleMessage = function() {
	this.settings.tooltipEl.classList.toggle('clicked')
}

// PhoneCta.prototype.changeForm = function(event) {
// 	let settings = this.settings; 
// 	let target = event.toElement;
// 	let formToHide = document.querySelector('.form-wrapper-all .instance.active');
// 	let formToShow = document.querySelector('div[data-instance="'+target.dataset.instance+'"]');
	
// 	settings.changeFormButtons.forEach(function(picker) {
// 		picker.classList.remove('active');
// 		target.classList.add('active');
// 	});

// 	settings.formElements.forEach(function(form) {
// 		form.classList.remove('active');
// 	});

// 	fadeOut(formToHide, function() {
// 		fadeIn(formToShow)
// 		target.classList.add('active');
// 		formToShow.classList.add('active');
// 	});

// }

PhoneCta.prototype.addEvent = function(elem, event, fn) {
	if (elem.addEventListener != null) {
		return elem.addEventListener(event, fn, false);
	} 
	else {
		return elem[event] = fn;
	}
}

PhoneCta.prototype.randomizeRequests = function(min, max) {
	var random = Math.floor(Math.random() * (max - min + 1)) + min;
	return random;
}

PhoneCta.prototype.printNumbers = function() {
	var numbers = this.settings.numberElements;
	for (var i = 0; i < numbers.length; i++) {
		numbers[i].innerHTML = this.randomizeRequests(this.settings.minCalls, this.settings.maxCalls);
	}
}

function fadeIn(el, display, cb){
	el.style.opacity = 0;
	el.style.display = display || "block";

	(function fade() {
		var val = parseFloat(el.style.opacity);
		if (!((val += .1) > 1)) {
			el.style.opacity = val;
			requestAnimationFrame(fade);

			if ( typeof cb == 'function' ) {
				cb();
			}
		}
	})();
};

function fadeOut(el, cb){
	var op = 1;  
	var timer = setInterval( function () {
		if (op <= 0.1){
			clearInterval(timer);

			el.style.display = 'none';

			if ( typeof cb == 'function') {
				cb();
			}
		}
		el.style.opacity = op;
		op -= 0.1;
	}, 50);
};

// Phone

window.onload = function() {

	// hide loader
	document.querySelector('html').classList.remove('no-scroll'); 
	document.querySelector('html').classList.add('loaded');	
	document.querySelector('body').classList.remove('no-scroll'); 
	document.querySelector('body').classList.add('loaded');	
	fadeOut(document.querySelector('.overlay-body'));
	// 

	let isMobile = window.innerWidth < 1023 ? true : false;

	let header = {}; 

	header.settings = {
		element: document.getElementById('masthead')	
	}

	header.init = function() {

		if ( !isMobile ) {
			window.onscroll = header.onScroll; 
			header.onScroll();
		}

	}

	header.onScroll = function() {

		let y = window.pageYOffset; 
		let s = header.settings;

		if (y > 10) {
			s.element.classList.add('scrolled');
		} else {
			s.element.classList.remove('scrolled');
		}

	}

	header.init();

	if ( typeof jQuery == 'function' ) {

		(function instanceCarousels() {

			let testimonials = {
				slidesToShow: 3,
				mobileFirst: false,
				responsive: [
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 1,
						arrows: false, 
						dots: true,
					}
				}
				]
			};

			$('.carousel').slick(testimonials);

			let basic = {
				slidesToShow: 1, 
				fade: true, 
				arrows: false, 
				dots: true,
				adaptiveHeight: true,
				autoplay: true, 
				autoplaySpeed: 4500
			}

			if ( isMobile ) {
				$('.becomes-carousel-on-mobile').slick(basic);
			}

		})();


		function showForm() {
			var el 

			if ( $(this).hasClass('upper') ) {
				el = '.specialist fieldset';
			} else if ( $(this).hasClass('middle') ) {
				el = '.free-evaluation'; 
			} else {
				el = '.ending-contact';
			}

			$(this).fadeOut(400, function(){
				$(el).fadeIn();
			});
		};

		$('.show-form').on('click', showForm);
	}

	/* 
	*
	* Handle form submits  
	* 
	* @params e = event 
	* @returns null 
	*
	*/

	function handleFormSubmits(e) {
		e.preventDefault(); 

		let form = this; 
		let data = new FormData(this);
		let filledValues = {}; 

		for ( let [key, value] of data.entries() ) {	
			if ( value != '' ) {
				filledValues[key] = value; 
			}
		}

		let redirect = filledValues.redirect; 

		$.ajax({
			url: '../mail-lp-ipiranga/sendmail.php',
			type: 'POST',
			data: filledValues,
		})
		.done(function(res) {
			swal("Sucesso!", "Seu E-mail foi enviado para o nosso departamento comercial, responderemos o mais breve possível.", "success");
			$(form).trigger('reset');
			ga('gtag_UA_37425064_1.send', 'event', 'Formulário', 'Envio', 'Ipiranga')
			// window.location = window.location.href + redirect;
		})
		.fail(function() {
			swal("Ops!", "Algo deu errado! \n Por favor tente novamente mais tarde ou entre em contato através deu um de nossos telefones.", "error");
		})
		.always(function() {
		});
		
	}

	document.querySelectorAll('form').forEach(function(el){
	 	el.addEventListener('submit', handleFormSubmits);
	});

	/* 
	* ###############
	* parallax scenes 
	* ###############
	*/

	let scenes = document.querySelectorAll('.parallax-scene'); 
	
	scenes.forEach(function(scene){
		new Parallax(scene, {
			relativeInput : true, 
		});
	});

	window.setTimeout(function(){
		let wow = new WOW().init();
	}, 300)

	/* 
	* ###############
	* phone cta instancing 
	* ###############
	*/

	let cta = new PhoneCta();

	function anchors(event) {
		// prevent default click behavior on <a>;
		event.preventDefault();

		// gather needed data such as where to scroll and possible offset. 
		var el = $(this).children('a'); 

		if ( $(this).is('a') ) {
			el = $(this);
		} 

		var val = el.prop('href'),
		hash = val.indexOf('#'),
		length = val.length,
		target = val.substring(hash, length);

		// animate html and body for a smooth scrolling if we're in the home page, 
		// redirect user otherwise

		$('html,body').animate({
			scrollTop: $(target).offset().top
		}, 500);

	}

	$('.is-anchor').on('click', anchors);

	(function maskInstancing() {
		var SPMaskBehavior = function (val) {
			return val.replace(/\D/g, '').length === 11 ? '(00) 00000-0000' : '(00) 0000-00009';
		},
			spOptions = {
				onKeyPress: function (val, e, field, options) {
					field.mask(SPMaskBehavior.apply({}, arguments), options);
				}
			};

		$('input[name="Telefone"], input[name="Celular"], input[name="Telefone Fixo"]').mask(SPMaskBehavior, spOptions);
	})();


}


